import * as React from 'react';
import './DashboardHeader.scss';

export interface DashboardHeaderProps {
  title: string;
}

export class DashboardHeader extends React.Component<DashboardHeaderProps> {

  title: string = 'KWC 3D Configurator';

  public render() {
    return (
      <div className="partial-dashboard-header mx-auto">
        <div className="heading">
          <h2>{this.props.title || this.title}</h2>
        </div>
      </div>
    );
  }
}

export default DashboardHeader;